<div class="auth-layout">
  <div class="auth-layout__logo">
    <app-logo [routerLink]="['/']"></app-logo>
  </div>
  <div class="auth-layout__panel">
    <ng-content></ng-content>
  </div>
  <div class="auth-layout__visual" aria-hidden="true">
    <img
      class="auth-layout__illustration"
      src="/assets/images/auth-layout/auth-illustration.webp"
      alt=""
      loading="lazy"
      decoding="async"
    />
  </div>
</div>
